import script from "./TextMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./TextMessage.vue?vue&type=script&setup=true&lang=js"

import "./TextMessage.vue?vue&type=style&index=0&id=206c4172&lang=css"

const __exports__ = script;

export default __exports__